(() => {
  const formatDuration = (seconds) => {
    if (!Number.isFinite(seconds) || seconds < 0) return '—:—';
    const total = Math.round(seconds);
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  const labelFromUrl = (url) => {
    try {
      const path = new URL(url, window.location.origin).pathname;
      const file = decodeURIComponent(path.split('/').pop() || '');
      const base = file.replace(/\.[^.]+$/, '');
      return base.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    } catch {
      return '';
    }
  };

  const initPlayer = (root) => {
    const player = root.querySelector('.brand-hero__player');
    const button = root.querySelector('.brand-hero__play');
    const audio = root.querySelector('.brand-hero__audio');
    const durationEl = root.querySelector('.brand-hero__sample-duration');
    const labelEl = root.querySelector('.brand-hero__sample-label');

    if (!player || !button) return;
    if (player.dataset.bound === 'true') return;
    player.dataset.bound = 'true';

    const setPlaying = (playing) => {
      player.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', playing ? 'true' : 'false');
    };

    const syncDuration = () => {
      if (!audio || !durationEl) return;
      if (Number.isFinite(audio.duration) && audio.duration > 0) {
        durationEl.textContent = formatDuration(audio.duration);
        durationEl.dataset.durationReady = 'true';
      }
    };

    const syncLabel = () => {
      if (!audio || !labelEl) return;
      if (player.dataset.autoLabel !== 'true') return;
      const fromUrl = labelFromUrl(audio.currentSrc || audio.getAttribute('src') || '');
      if (fromUrl) {
        labelEl.textContent = fromUrl;
        button.setAttribute('aria-label', fromUrl);
      }
    };

    button.addEventListener('click', async () => {
      if (!audio || !audio.getAttribute('src')) {
        setPlaying(!player.classList.contains('is-playing'));
        return;
      }

      try {
        if (audio.paused) {
          await audio.play();
          setPlaying(true);
        } else {
          audio.pause();
          setPlaying(false);
        }
      } catch {
        setPlaying(false);
      }
    });

    if (audio) {
      audio.addEventListener('loadedmetadata', () => {
        syncDuration();
        syncLabel();
      });
      audio.addEventListener('durationchange', syncDuration);
      audio.addEventListener('ended', () => setPlaying(false));
      audio.addEventListener('pause', () => {
        if (!audio.ended) setPlaying(false);
      });

      // Some browsers need load() after setting preload=metadata
      try {
        audio.load();
      } catch {
        /* ignore */
      }

      syncDuration();
      syncLabel();
    }
  };

  const getScrollContainer = () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      return document.querySelector('.page-wrapper') ?? document.scrollingElement ?? document.documentElement;
    }
    return document.scrollingElement ?? document.documentElement;
  };

  const initScrollCue = (root) => {
    const cue = root.querySelector('.brand-hero__scroll');
    if (!cue || cue.dataset.bound === 'true') return;
    cue.dataset.bound = 'true';

    cue.addEventListener('click', () => {
      const currentSection = root.closest('.shopify-section') || root;
      const nextSection = currentSection.nextElementSibling;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduced ? 'instant' : 'smooth';
      const container = getScrollContainer();

      if (nextSection) {
        const containerRect = container.getBoundingClientRect();
        const targetTop = nextSection.getBoundingClientRect().top - containerRect.top + container.scrollTop;
        container.scrollTo({ top: targetTop, behavior });
        return;
      }

      container.scrollBy({ top: window.innerHeight, behavior });
    });
  };

  const initHero = (root) => {
    initPlayer(root);
    initScrollCue(root);
  };

const boot = () => {
  document.querySelectorAll('.brand-hero, .brand-purchase').forEach(initHero);
};

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
  const section =
    event.target?.querySelector?.('.brand-hero') ||
    event.target?.querySelector?.('.brand-purchase') ||
    event.target;
  if (
    section?.classList?.contains('brand-hero') ||
    section?.classList?.contains('brand-purchase')
  ) initHero(section);
});

})();
